/* custom-variant-media.js — show only the selected variant's own photo
 *
 * Dawn renders the entire product gallery no matter which variant is selected.
 * On Urethane Commercial Weight Plates that meant picking the 5 lb still showed
 * the "photo not available" placeholders for the 10 lb and 25 lb underneath it.
 *
 * Rule, deliberately blunt: if a variant has its own image, that image is the
 * ONLY one shown. No thumbnails, no extra slides underneath.
 *
 * HISTORY — why this is the second attempt.
 * The first version matched on alt text ("... — 10 lbs") and hid images claimed
 * by a different option value. It also carried a guard: don't hide anything
 * unless some image claims the CURRENT selection. On this product the 5 lb, 35 lb
 * and 45 lb use generically-named photos that claim nothing, so the guard fired
 * every time and the gallery was never filtered. The guard defeated the feature.
 * Matching on variant.featured_media.id instead removes the guesswork entirely.
 *
 * Fails open in exactly one case: a variant with no image of its own leaves the
 * gallery untouched, because hiding everything would be worse than showing too
 * much.
 */
(function () {
  'use strict';

  var cache = {};

  function handle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function selectedVariantId() {
    var form = document.querySelector('form[action*="/cart/add"]');
    var input = form && form.querySelector('input[name="id"]');
    if (input && input.value) return String(input.value);
    var u = new URLSearchParams(window.location.search).get('variant');
    return u ? String(u) : null;
  }

  function mediaIdOf(el) {
    // Dawn: data-media-id="{{ section.id }}-{{ media.id }}"
    var raw = el.getAttribute('data-media-id') || '';
    var parts = raw.split('-');
    return parts.length ? parts[parts.length - 1] : '';
  }

  function apply(product) {
    var items = document.querySelectorAll('.product__media-item, li.product__media-item');
    if (!items.length || !product || !product.variants) return;

    var vid = selectedVariantId();
    if (!vid) return;

    var variant = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === vid) { variant = product.variants[i]; break; }
    }
    if (!variant) return;

    var fm = variant.featured_media || variant.featured_image;
    // No image of its own — leave the gallery alone rather than empty it.
    if (!fm || fm.id == null) {
      items.forEach(function (li) { li.style.display = ''; });
      return;
    }
    var keep = String(fm.id);

    var shown = 0;
    items.forEach(function (li) {
      var match = mediaIdOf(li) === keep;
      li.style.display = match ? '' : 'none';
      li.setAttribute('data-goat-media', match ? 'shown' : 'hidden');
      if (match) shown++;
    });

    // Never leave an empty gallery. If the id did not line up with any item,
    // put everything back rather than show a blank space where photos were.
    if (shown === 0) {
      items.forEach(function (li) { li.style.display = ''; li.removeAttribute('data-goat-media'); });
      return;
    }

    // The thumbnail strip has to follow, or it lists photos the gallery hides.
    document.querySelectorAll('.thumbnail-list__item').forEach(function (t) {
      var btn = t.querySelector('[data-target]');
      var target = btn ? btn.getAttribute('data-target') || '' : '';
      var id = target.split('-').pop();
      var match = id === keep;
      t.style.display = match ? '' : 'none';
    });
  }

  function run() {
    var h = handle();
    if (!h) return;
    if (cache[h]) { apply(cache[h]); return; }
    fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (!p) return; cache[h] = p; apply(p); })
      .catch(function () { /* leave the gallery alone */ });
  }

  function init() {
    run();
    document.addEventListener('change', function (ev) {
      if (ev.target && ev.target.closest && ev.target.closest('variant-selects')) setTimeout(run, 60);
    });
    document.addEventListener('shopify:section:load', function () { setTimeout(run, 60); });
    if (window.MutationObserver) {
      var g = document.querySelector('media-gallery, .product__media-list');
      if (g) {
        new MutationObserver(function () { setTimeout(run, 0); })
          .observe(g, { childList: true, subtree: true });
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
